import { render, staticRenderFns } from "./ShowOrdersToggle.vue?vue&type=template&id=0f91f226&scoped=true"
import script from "./ShowOrdersToggle.vue?vue&type=script&lang=js"
export * from "./ShowOrdersToggle.vue?vue&type=script&lang=js"
import style0 from "./ShowOrdersToggle.vue?vue&type=style&index=0&id=0f91f226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f91f226",
  null
  
)

export default component.exports